import {each, generate, last, reduce} from '../lang/array';
import {times} from '../lang/function';
import {ceil, floor, pow} from '../lang/number';

const
    utf8 = string => (
        unescape(
            encodeURIComponent(
                string))),

    rotate = (x, n) => (
        (x << n) | (x >>> (32 - n))),

    scramble = (type, x, y, z) => (
        type === 0 ?
            (x & y) ^ (~x & z) :
            (type === 2 ?
                (x & y) ^ (x & z) ^ (y & z) :
                x ^ y ^ z)),

    hex = n => (
        generate(
            8,
            i => (0xf & (n >>> ((7 - i) * 4))).toString(16))
        .join('')),

    blocks = string => {
        const
            encoded = (
                unescape(
                    encodeURIComponent(
                        string))),
            message = encoded + String.fromCharCode(0x80),
            blocks = (
                generate(
                    ceil(((message.length / 4) + 2) / 16),
                    i => (
                        generate(16, j => {
                            const offset = ((i * 64) + (j * 4));

                            return (
                                (message.charCodeAt(offset + 0) << 24) |
                                (message.charCodeAt(offset + 1) << 16) |
                                (message.charCodeAt(offset + 2) << 8) |
                                (message.charCodeAt(offset + 3) << 0));
                        }))));
        last(blocks)[14] = floor((encoded.length * 8) / pow(2, 32));
        last(blocks)[15] = 0xffffffff & (encoded.length * 8);
        return blocks;
    },

    waves = block => {
        const wave = new Array(80);

        times(16, i => {
            wave[i] = block[i];
        });
        times(80 - 16, i => {
            i += 16;
            wave[i] = (
                rotate(
                    wave[i- 3] ^ wave[i - 8] ^ wave[i - 14] ^ wave[i - 16],
                    1));
        });
        return wave;
    },

    constants = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ],

    seeds = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];

export default (
    string => (
        reduce(
            reduce(
                blocks(string),
                (hashes, block) => {
                    const next = hashes.slice();

                    each(waves(block), (wave, i) => {
                        const type = floor(i / 20);

                        each(
                            [
                                0xffffffff & (
                                    (rotate(next[0], 5) +
                                    scramble(type, next[1], next[2], next[3]) +
                                    next[4] +
                                    constants[type] +
                                    wave)),
                                next[0],
                                rotate(next[1], 30),
                                next[2],
                                next[3]
                            ],
                            (value, i) => {
                                next[i] = value;
                            });
                    });
                    each(next, (hash, i) => {
                        hashes[i] = (hashes[i] + hash) & 0xffffffff;
                    });
                    return hashes;
                },
                seeds.slice()),
            (string, hash) => `${string}${hex(hash)}`,
            '')));
